module.exports = __webpack_public_path__ + "static/img/button.7efa0778.png";